export var getLocalStorage = function getLocalStorage() {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    var mod = '__storage_test__';
    window.localStorage.setItem(mod, mod);
    window.localStorage.removeItem(mod);
    return window.localStorage;
  } catch (e) {
    // режим инкогнито
    return null;
  }
};